'use client';
import { atom } from 'jotai';

import { AllExperiments } from '../Entities/Experiments.entities';

const experimentsAtom = atom<AllExperiments>([]);

export { experimentsAtom };
